export const GET_VEHICLES = 'GET_VEHICLES';
export const IS_FETCHING = 'IS_FETCHING';
export const IS_FETCHING_SHOW_MORE = 'IS_FETCHING_SHOW_MORE';
export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_ACCESS_VEHICLES_SELECTED = 'SET_ACCESS_VEHICLES_SELECTED';
export const CLEAN = 'CLEAN';
export const SET_VISIT_VEHICLE_SELECTED = 'SET_VISIT_VEHICLE_SELECTED';